import { render, staticRenderFns } from "./DocumentMove.vue?vue&type=template&id=46dcb63c&scoped=true&"
import script from "./DocumentMove.vue?vue&type=script&lang=js&"
export * from "./DocumentMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcb63c",
  null
  
)

export default component.exports